const $ = require('jquery')

export const showMobileOffersTable = {
  init (events, calendar) {
    const tableElement = $('#table-offers-content')
    if (!tableElement.length) {
      return
    }
    const mobileHidingWrapper = tableElement.closest('.hidden-xs')
    if (!mobileHidingWrapper.length) {
      return
    }
    const offersForm = mobileHidingWrapper.find('form')
    if (offersForm.length) {
      events.formsListUpdated.subscribe(() => {
        calendar.init(offersForm[0])
      })
    }

    mobileHidingWrapper.removeClass('hidden-xs')
    mobileHidingWrapper.addClass('table-offers-wrapper')
  },
}


// WEBPACK FOOTER //
// ./src/modules/showMobileOffersTable.js